module.exports = __webpack_public_path__ + "media/images/illust/avatar-5b60cf7f0f753418d10274d559dc1c2c.png";